import { toast } from "react-toastify";
import { GET, POST, setAuthToken } from "../config/ApiConfig";
import { apiError } from "../helpers/ErrorHelper";

export const create = async (user_token, url, formData) => {
  setAuthToken(user_token);

  return await POST(`${url}?quick=1`, formData);
};

export const getOptions = async (param = {}) => {
  let user_token = param.user_token;

  if (! user_token) {
    return [];
  }

  try {
    setAuthToken(user_token);

    let url = param.url;
    if (-1 != url.indexOf('?')) {
      url += '&page=1&limit=-1';
    } else {
      url += '?page=1&limit=-1';
    }

    const response = await GET(url);
    if (! response.status) { 
      toast.error(response.message);
    }

    return response.data;
  } catch (error) {
      apiError(error);
  }
};
